import {
    cookieStorageEngine,
    localStorageEngine,
    sessionStorageEngine,
} from '@muse-web/persist-engines'
import type { TEnginesMap } from '@muse/store'

export const persistEngines = [localStorageEngine, sessionStorageEngine, cookieStorageEngine]

declare module '@muse/store' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface MusePersistEngines extends TEnginesMap<typeof persistEngines> {}
}
